import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import { ShoppingCart } from 'lucide-react';

export default function VendasLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const userData = await login(email, password);
      
      // Verificar se tem acesso ao módulo de vendas
      const hasVendasAccess = userData?.role === 'vendedor' || 
        userData?.role === 'admin' || 
        userData?.acesso_vendas === true;
      
      if (!hasVendasAccess) {
        toast.error('Você não tem permissão para acessar o módulo de vendas');
        setLoading(false);
        return;
      }
      
      // Salvar user no localStorage para Vendas.js poder ler
      localStorage.setItem('user', JSON.stringify(userData));
      
      toast.success(`Bem-vindo, ${userData.name}!`);
      navigate('/vendas');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Credenciais inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
            <ShoppingCart className="h-8 w-8 text-primary" />
          </div>
          <h1 className="text-4xl font-bold font-manrope mb-2">Serraria Guedes</h1>
          <p className="text-muted-foreground">Módulo de Vendas</p>
        </div>

        <Card className="border-border">
          <CardHeader>
            <CardTitle className="font-manrope">Entrar</CardTitle>
            <CardDescription>
              Entre com suas credenciais para acessar o módulo de vendas
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="seu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="vendas-email-input"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">Senha</Label>
                <Input
                  id="password"
                  type="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  data-testid="vendas-password-input"
                />
              </div>
              <Button
                type="submit"
                className="w-full"
                disabled={loading}
                data-testid="vendas-submit-button"
              >
                {loading ? 'Carregando...' : 'Entrar'}
              </Button>
            </form>

            <p className="mt-4 text-center text-xs text-muted-foreground">
              Acesso restrito a usuários autorizados.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
